import { Module, ActionTree, MutationTree, GetterTree } from 'vuex'
import type { RootState } from "store";
import { ProfileState } from './types'
import { ProfileService } from "../service"

const service = new ProfileService()

const state: ProfileState = {}

const getters: GetterTree<ProfileState, RootState> = {}

const mutations: MutationTree<ProfileState> = {}

const actions: ActionTree<ProfileState, RootState> = {
  async selectWorkingHour({ commit }, params: any) {
    const data = await service.selectWorkingHour(params)
    return data
  },

  async selectTopApprover({ commit }, params: any) {
    const data = await service.selectTopApprover(params)
    return data.data.map((item: any) => {
      return {
        ...item,
        total: item.totalApproved,
        totalApprover: data["totalApproved"],
      }
    })
  },

  async updateAvatar({ commit }, params: any) {
    const data = await service.updateAvatar(params)
    return data
  },

  async forceLogout({ commit }) {
    await service.patchForceLogout()
    return
  },
}

export const profile: Module<ProfileState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

